// @ts-nocheck



import React from 'react';

import { branchBudgetSummaryApi } from '../../lib/api';


import AutocompleteSelect from './AutocompleteSelect';




export default ({ filter = {}, ...props }) =>
<AutocompleteSelect
  placeholder="Выберите свод бюджета по филиалу"
  fetch={async (params) => {
    return await branchBudgetSummaryApi.fetch({
      ...filter,
      ...params
    });
  }}
  fetchSingle={branchBudgetSummaryApi.get}
  notFoundText="Своды не найдены"
  renderOption={(branchBudgetSummary, Option) =>
  <Option
    value={branchBudgetSummary.id}
    key={branchBudgetSummary.id}
    branchBudgetSummary={branchBudgetSummary}>

        {`${branchBudgetSummary.id}${
    branchBudgetSummary.name ? ` - ${branchBudgetSummary.name}` : ''}`
    }
      </Option>
  }
  {...props} />;
